export default [
  {
    for: 'article',
    actions: {
      read: true,
    },
  },
  {
    for: 'audioplayer',
    actions: {
      read: true,
    },
  },
  {
    for: 'channel',
    actions: {
      read: true,
    },
  },
  {
    for: 'collection',
    actions: {
      read: true,
    },
    excludedProperties: ['text'],
  },
  {
    for: 'calendar-event',
    actions: {
      read: true,
    },
  },
  {
    for: 'live-event',
    actions: {
      read: true,
    },
  },
  {
    for: 'media-event',
    actions: {
      read: true,
    },
  },
  {
    for: 'media-embed',
    actions: {
      read: true,
    },
  },
  {
    for: 'mlp',
    actions: {
      read: true,
    },
    excludedProperties: [
      'cmsState',
      'isMultiArtistPage',
      'options.customCSS',
      'options.customHeader',
      'options.customJs',
      'options.customContainerClass',
      'options.customContainerId',
      'options.customOptions',
      'options.template',
      'sso',
      'shopifyStore',
      'shopifyHasCartPage',
      'template',
      'theme',
      'thumbnail',
      'vhost',
      'version',
    ],
  },
  {
    for: 'product',
    actions: {
      read: true,
    },
  },
  {
    for: 'product-family',
    actions: {
      read: true,
    },
  },
  {
    for: 'teaser',
    actions: {
      read: true,
    },
    excludedProperties: ['youniverseStageAssets', 'youniverseScreenAssets'],
  },
  {
    for: 'story',
    actions: {
      read: true,
    },
  },
  {
    for: 'artist',
    actions: {
      read: true,
    },
  },
  {
    for: 'url-alias',
    actions: {
      read: true,
    },
  },
  {
    for: 'asset',
    actions: {
      read: true,
    },
  },
  {
    for: 'link',
    actions: {
      read: true,
    },
  },
];
